export const sideMarketsIcon = (size: number) => (
	<svg width={size} height={size} viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18 0V24H26V0H18ZM20 2H24V22H20V2ZM0 6V24H8V6H0ZM2 8H6V22H2V8ZM9 12V24H17V12H9ZM11 14H15V22H11V14Z"
			fill="black"
		/>
	</svg>
);
